<script setup>

import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {computed, ref, watch} from "vue";
import HealthcheckRow from "@/components/backlinks/healthcheck/partials/HealthcheckRow.vue";
import {getBacklinkHealthcheck} from "@/composables/backlinks/useBacklinkHealthcheck";
import {useInfiniteScroll} from "@vueuse/core";
import useHealthcheckStore from "@/composables/backlinks/useHealthcheckStore";

const { search, activeTab, maxDomainAuthority } = useHealthcheckStore();

const tableBody = ref(null);
const visibleRows = ref(50);

watch(
  activeTab,
  () => visibleRows.value = 50
)

useInfiniteScroll(
  computed(() => tableBody.value?.$el),
  () => {
    visibleRows.value += 50;
  },
  {
    distance: 200,
  }
);

const {data: backlinksData, isLoading} = getBacklinkHealthcheck(maxDomainAuthority);

const backlinks = computed(() => {
    let backlinks = backlinksData.value.pending;

    if (activeTab.value === 'kept') {
      backlinks = backlinksData.value.kept;
    }

    if (activeTab.value === 'disavowed') {
      backlinks = backlinksData.value.disavowed;
    }

    return backlinks
      .filter(backlink => backlink.domain.toLowerCase().includes(search.value.toLowerCase()))
      .slice(0, visibleRows.value);
  }
)

const expandedRow = ref(null);

const toggleRow = (row) => {
  expandedRow.value = expandedRow.value === row.domain ? null : row.domain;
};
</script>

<template>
  <LoadingBlock v-if="isLoading" />

  <DataTable v-else>
    <TableBody
      v-if="backlinks?.length > 0"
      ref="tableBody"
      class="tw-max-h-[70vh]"
    >
      <HealthcheckRow
        v-for="backlink in backlinks"
        :key="backlink.domain"
        :backlink="backlink"
        :is-expanded="expandedRow === backlink.domain"
        @toggle="toggleRow(backlink)"
      />
    </TableBody>

    <ZeroContent v-else>
      Looks like there are no backlinks to display.
    </ZeroContent>
  </DataTable>
</template>

